export const metaInfo = {
  title: "My Example App",
  titleTemplate: "%s - Yay!",
  htmlAttrs: {
    lang: "en",
    amp: true
  }
};
